<script lang="ts" setup>
import { computed } from 'vue';
import { Drag } from '@/components/dragdrop';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { DetailsBuilderContract } from '@/components/builder/details';
import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';
import { BlueprintDefinition } from '@/components/builder/details/blueprints/BlueprintDefinition';

defineOptions({
    name: 'dynamic-details-component-button',
    components: {
        'drag': Drag
    }
});

const props = defineProps({
  "definition": null,
  "details": null
});
const emit = defineEmits(["click"]);

const requiredSpace = computed(() =>
{
    if (props.definition)
    {
        const component = props.details.layout.createComponent(props.definition.type) as HasWidth;

        return component.minWidth;
    }

    return 0;
});

const disabled = computed(() =>
{
    const row = props.details.clipboard.getTarget() as AggregateBlueprint;

    return props.details.clipboard.isRowSelected()
        ? (props.details.schema.parent(row, props.definition.type) !== null || props.details.dimensions.available(row) < requiredSpace.value)
        : true;
});

const onClick = (e: any): void =>
{
    emit('click', props.definition);
};

</script>

<template>
    <div class="col">
        <drag :transfer-data="{ definition: definition }" :draggable="!disabled">
            <button class="text-start text-nowrap text-truncate" :title="$t(definition.name)" :disabled="disabled" @click.prevent="onClick">
                <i v-if="definition.icon" class="fa-fw far me-2" :class="definition.icon"></i>
                {{ $t(definition.name) }}
            </button>
        </drag>
    </div>
</template>

<style lang="scss" scoped>
button {
    border: none;
    background: transparent;
    padding: 0.5rem;
    border-radius: 4px;
    width: 100%;

    &:hover:not(:disabled) {
        background: var(--bs-secondary-bg);
    }

    &:disabled {
        opacity: 0.3;
    }

    i {
        font-size: 1rem !important;
    }
}
</style>
